import React from 'react';
import Title from "../../customer/ProductsCustomer/Title";
import CheckoutNewAffinity from "./Checkout/CheckoutNewAffinity";
import useStyles from "../Cotizar/VehiculoForm/Checkout/styles";

function AddAffinityPage(props) {

    return (
        <React.Fragment>
            {typeof props.editInfo !== 'undefined'
                ? <CheckoutNewAffinity editInfo={props.editInfo}/>
                : <CheckoutNewAffinity/>
            }
        </React.Fragment>
    );
}

export default AddAffinityPage;